import React, { Component } from "react";
import { Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import LinkSite from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Circular from "components/Circular/Circular";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import icon from "../../assets/img/icon.png";
import backgroundImage from "../../assets/img/flexibilidade_7.jpg";

const useStyles = (theme) => ({
  root: {
    height: "100vh",
    "& .MuiTypography-root": {
      padding: "20px 0 0 0",
    },
  },
  image: {
    backgroundImage: `url(${backgroundImage})`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type ==="dark"
        ? theme.palette.grey[900]
        : theme.palette.grey[50],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  paperBackground: {
    background: "#F1F1F2",
  },
  img: {
    width: "100px",
    height: "100px",
  },
  span: {
    "& .MuiTypography-root": {
      color: "gray",
    },
    display: "block !important",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  green: {
    "& label.Mui-focused": {
      color: "green",
    },

    borderColor: "green !important",
  },
  red: {
    "& label.Mui-focused": {
      color: "red",
    },
    color: "red",
    borderColor: "red !important",
  },
  circular: {
    position: "absolute !important",
    top: "320px !important",
  },
});

class RegiterSide extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.copyright = this.copyright.bind(this);
    this.handlePassChange = this.handlePassChange.bind(this);
    this.handleUserChange = this.handleUserChange.bind(this);
    this.handleUserNameChange = this.handleUserNameChange.bind(this);
    this.handleCompanyChange = this.handleCompanyChange.bind(this);
    this.state = {
      username: "",
      password: "",
      name: "",
      company: "",
      invalid: false,
      error: false,
      circular: false,
    };
  }

  handleUserNameChange(e) {
    this.setState({ name: e.target.value, error: false, invalid: false });
  }

  handleUserChange(e) {
    this.setState({ username: e.target.value, error: false, invalid: false });
  }

  handlePassChange(e) {
    this.setState({ password: e.target.value, error: false, invalid: false });
  }

  handleCompanyChange(e) {
    this.setState({ company: e.target.value, error: false, invalid: false });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ circular: true }, () => {
      let { name, username, password, company } = this.state;
      if (!name || !username || !password || !company) {
        return this.setState({ error: true, circular: false });
      }
    });
  }

  copyright() {
    return (
      <Typography variant="body2" color="textSecondary" align="center">
        {"Copyright © "}
        <LinkSite color="inherit" href="http://qira.com.br/">
          Qirá Tecnologia
        </LinkSite>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    );
  }

  render() {
    let { classes } = this.props;
    let {
      error,
      name,
      username,
      password,
      circular,
      invalid,
      company,
    } = this.state;

    return (
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <Grid item xs={false} sm={4} md={7} className={classes.image} />
        <Grid
          item
          xs={12}
          sm={8}
          md={5}
          component={Paper}
          elevation={6}
          square
          className={classes.paperBackground}
        >
          <div className={classes.paper}>
            <img src={icon} className={classes.img} />
            <Typography component="h1" variant="h5">
              {circular ? null : "Registrar"}
            </Typography>
            {circular ? (
              <div className={classes.circular}>
                <Circular />
              </div>
            ) : (
              <form
                className={classes.form}
                noValidate
                onSubmit={this.handleSubmit}
              >
                <TextField
                  className={error && !name ? classes.red : classes.green}
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  InputProps={{
                    classes: {
                      notchedOutline:
                        error && !name ? classes.red : classes.green,
                    },
                  }}
                  id="name"
                  label="Nome do Usuário"
                  name="name"
                  autoComplete="name"
                  autoFocus
                  value={name}
                  onChange={this.handleUserNameChange}
                />
                <TextField
                  className={error && !company ? classes.red : classes.green}
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  InputProps={{
                    classes: {
                      notchedOutline:
                        error && !company ? classes.red : classes.green,
                    },
                  }}
                  id="company"
                  label="Empresa do Usuário"
                  name="company"
                  autoComplete="company"
                  autoFocus
                  value={company}
                  onChange={this.handleCompanyChange}
                />
                <TextField
                  className={error && !username ? classes.red : classes.green}
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  InputProps={{
                    classes: {
                      notchedOutline:
                        error && !username ? classes.red : classes.green,
                    },
                  }}
                  id="email"
                  label="Email"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  value={username}
                  onChange={this.handleUserChange}
                />
                <TextField
                  className={error && !password ? classes.red : classes.green}
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  InputProps={{
                    classes: {
                      notchedOutline:
                        error && !password ? classes.red : classes.green,
                    },
                  }}
                  name="password"
                  label="Senha"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={this.handlePassChange}
                />
                {invalid ? (
                  <p className={classes.red}>Usuário já existe!</p>
                ) : null}
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Registrar
                </Button>
                <Grid container>
                  <Grid item>
                    <LinkSite href="/signIn" variant="body2">
                      {"Já possui uma conta? Log In"}
                    </LinkSite>
                  </Grid>
                </Grid>
                <Box mt={5}>{this.copyright}</Box>
              </form>
            )}
          </div>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(RegiterSide);
